import script from "./BottomNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&setup=true&lang=js"

import "./BottomNavBar.vue?vue&type=style&index=0&id=1353d880&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1353d880"]])

export default __exports__